// extracted by mini-css-extract-plugin
export var container = "_uo-0";
export var table = "_uo-2";
export var tableWrapper = "_uo-1";